import Axios from 'axios';
const ServiceURL = process.env.VUE_APP_SERVICEURL

export default {
    name: 'status',
    state: {
        allGA: [],
    },
    getters: {
        getGA: state => {
            return state.allGA
        },
    },
    mutations: {
        SET_GA: (state, payload) => {
            state.allGA = payload
        },
    },
    actions: {
        async FETCH_GA(store) {
            return await Axios({
                method: "get",
                url: ServiceURL + "main/approval_ga",
                auth: {
                    username: store.rootState.user.auth.username,
                    password: store.rootState.user.auth.password
                },
                headers: {
                    "X-API-KEY": store.rootState.user.auth.apikey
                }
            }).then(response => {
                store.commit('SET_GA', response.data.data)
            })
                .catch(err => {
                    return err
                });
        },
    }
}